export const ALERTS_TITLE = "activation.home.alerts.title";
export const VIEW_ALL_ALERTS = "project.preview.insights.footer.button";
export const TRACK_KEYWORDS_TITLE = "activation.home.alert.track.keywords.title";
export const TRACK_KEYWORDS_TEXT = "activation.home.alert.track.keywords.text";
export const MONITOR_LANDINGS_TITLE = "activation.home.alert.monitor.landings.title";
export const MONITOR_LANDINGS_TEXT = "activation.home.alert.monitor.landings.text";
export const ALERTS_TOAST_MESSAGE = "activation.home.alerts.toast.message";
export const ALERTS_TOAST_BUTTON = "activation.home.alerts.toast.button";
export const ALERTS_ITEM_TITLE = "activation.platform-alerts.card.title";
export const ALERTS_EMPTY_STATE_TITLE = "platform.alerts.endOfResults.title";
export const ALERTS_EMPTY_STATE_TEXT = "activation.home.alert.emptyState.text";
